import { RestClient } from '@/api/rest-client'
import { Contact } from '@/api/model/contact'

export class ContactClient extends RestClient<Contact> {
    collectionName = 'contacts'
    parseData = Contact.fromData
}
